// Normalize identifiers from available engagements and existing cycle links.
export const engagementId = (item) => Number(item.engagementId || item.id);

const isYes = (value) => value === true || /^(y|yes)$/i.test(String(value));

export const engagementQuickFilters = [
  {
    id: "highRisk",
    label: "High risk",
    matches: (item) => {
      const engagement = item.engagement || item;
      return (
        isYes(engagement.riskHighRiskIndustry) ||
        [
          engagement.riskLevel,
          engagement.riskRating,
          engagement.client?.riskLevel,
        ].some((level) => /^high$/i.test(String(level))) ||
        (engagement.riskAssignments || []).some(
          (risk) => risk.included && /^high$/i.test(risk.riskLevel)
        )
      );
    },
  },
  {
    id: "firstYear",
    label: "First-year audit engagement",
    matches: (item) =>
      isYes((item.engagement || item).riskNewClient) &&
      /^audit$/i.test(engagementValue(item, "type")),
  },
  {
    id: "neverInspected",
    label: "Never inspected",
    matches: (item) => (item.engagement || item).inspectionCount === 0,
  },
];

// Read selection metadata from either engagement response shape.
export const engagementValue = (item, field) => {
  const value =
    field === "partner"
      ? item.engagementPartner || item.engagement?.engagementPartner
      : field === "type"
      ? item.workType || item.engagement?.workType
      : item.riskLevel || item.riskRating || item.engagement?.riskLevel;
  return (typeof value === "string" ? value : value?.name || "").trim();
};
